"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeType = void 0;
var ThemeType;
(function (ThemeType) {
    ThemeType["light"] = "light";
    ThemeType["dark"] = "dark";
})(ThemeType || (exports.ThemeType = ThemeType = {}));
//# sourceMappingURL=theme.js.map